<template>
  <v-card>
    <v-toolbar
      color="cyan"
      dark
      flat
    >
      <v-tabs
        v-model="tab"
        fixed-tabs
        dark
        align-with-title
      >
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab
          v-for="item in items"
          :key="item"
          @click="Status(item)"
        >
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="item in items"
        :key="item"
      >
        <v-card flat>
          <v-card-text>
            <template>
              <v-card-title>
                {{ status }}
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="desserts"
                :search="search"
              >
                <template #[`item.status_order`]="{ item }">
                  <v-chip
                    :color="getColor(item.status_order)"
                    dark
                    v-text="ChangeStatus(item.status_order)"
                  >
                  </v-chip>
                </template>
              </v-data-table>
            </template>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      tab: null,
      items: [
        'Hotel', 'Transport', 'Activity', 'Entrance', 'Restaurant',
      ],
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      status: 'Hotel',
      search: '',
      datenow: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      headers: [
        {
          text: 'Id Tour',
          align: 'start',
          sortable: false,
          value: 'tour_code',
        },
        { text: 'Travel Date', value: 'travel_date' },
        { text: 'Name Itinerari', value: 'name_itinerari' },
        { text: 'Guest Name', value: 'guest_name' },
        { text: 'Status', value: 'status_order' },
      ],
      desserts: [],
    }
  },
  mounted() {
    this.initialize()
  },
  methods: {
    getColor(date) {
      if (this.datenow <= date) {
        return 'primary'
      } if (this.datenow >= date) {
        return 'error'
      }

      return 'error'
    },
    ChangeStatus(date) {
      if (this.datenow <= date) {
        return 'On Going'
      } if (this.datenow >= date) {
        return 'Passed'
      }

      return 'Passed'
    },
    Status(item) {
      this.status = item
      this.initialize()
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/StatusTour', { status_tour: this.status }).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.desserts = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },

  },
}
</script>
